<div class="p-grid p-justify-center">
  <cre-spinner [size]="'md'" [hidden]="!isLoading"></cre-spinner>
</div>
<div class="awards-background" [ngClass]="awardsSummary?.lastYearAward" *ngIf="!isLoading">
  <div class="thropy-details">
    <app-wig-awards-stats
      [awardsSummary]="awardsSummary"
      [claimURL]="claimURL"
      (storeClosedEvent)="loadAwardsStatus()"
    >
    </app-wig-awards-stats>
  </div>
  <div class="thropy-background" [ngClass]="awardsSummary?.lastYearAward"></div>
</div>
<app-wig-awards-months
  [awardsSummary]="awardsSummary"
  *ngIf="awardsSummary && awardsSummary.earnedPoints.length > 0 && !isLoading"
>
</app-wig-awards-months>
